export enum Cookies_status {
    AGREED = "agreed",
    DISAGREED = "disagreed",
    NULL = "null",
}
